export default __webpack_public_path__ + "static/media/tour-unity-loader.03f198e3.gif";